// Same property as supergrow.ai, so the shared _ga cookie keeps the visitor's original source.
const MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;

export function initGA4() {
  if (!import.meta.env.PROD || !MEASUREMENT_ID) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackSignupCompleted(userId, properties) {
  if (!window.gtag) return;
  window.gtag("set", { user_id: userId });
  window.gtag("event", "signup_completed", properties);
}
